import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';

function Pager(props) {
  const { intl } = props;
  let first = null;
  let previous = null;
  let pages = [];
  let next = null;
  let last = null;

  const scrollTo = () => {
    setTimeout(() => {
      // IE fallback.
      try {
        document.querySelector('.sortbar--toggle').scrollIntoView({ behavior: "smooth" })
      } catch (error) {
        console.log("The browser doesn't support Smooth scroll")
      }
    }, 500);
  }

  if (props.first && Object.keys(props.first).length) {
    first =
      <li className="pagination__item" data-rs-pagination-control="data-rs-pagination-control">
        <Link onClick={scrollTo} to={props.first.url} onMouseDown={props.first.onMouseDown} title={intl.formatMessage({ id: "Pager.GoToFirstTitle" })}>
          <span aria-hidden={true}>{intl.formatMessage({ id: "Pager.GoToFirstLabel" })}</span>
          <span className="hidden--visually">{intl.formatMessage({ id: "Pager.GoToFirstHidden" })}</span>
        </Link>
      </li>;
  }

  if (props.previous && Object.keys(props.previous).length) {
    previous =
      <li className="pagination__item" data-rs-pagination-control="data-rs-pagination-control">
        <Link className="pagination__control" onClick={scrollTo} to={props.previous.url} onMouseDown={props.previous.onMouseDown} title={intl.formatMessage({ id: "Pager.GoToPreviousTitle" })} rel="prev">
          <span className="icon icon--inline" aria-hidden={true}>
            <svg>
              <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#arrow-left" />
            </svg>
          </span>
          <span className="hidden--visually">{intl.formatMessage({ id: "Pager.GoToPreviousHidden" })}</span>
        </Link>
      </li>;
  }

  if (props.pagesList) {
    for (let id in props.pagesList) {
      let page = props.pagesList[id];
      let link = null;

      if (page.isCurrent) {
        link =
          <li key={id} className="pagination__item">
            <span className="hidden--visually">{intl.formatMessage({ id: "Pager.CurrentPageHidden" })}</span>
            <span>{page.text}</span>
          </li>
      }
      else {
        link =
          <li key={id} className="pagination__item">
            <Link onClick={scrollTo} to={page.url} onMouseDown={page.onMouseDown} title={intl.formatMessage({ id: "Pager.GoToPage" }, { text: page.text })} className="link">
              <span className="hidden--visually">{intl.formatMessage({ id: "Pager.PageHidden" })}</span>
              <span>{page.text}</span>
            </Link>
          </li>
      }

      pages.push(link);
    }
  }

  if (props.next && Object.keys(props.next).length) {
    next =
      <li className="pagination__item" data-rs-pagination-control="data-rs-pagination-control">
        <Link className="pagination__control" onClick={scrollTo} to={props.next.url} onMouseDown={props.next.onMouseDown} title={intl.formatMessage({ id: "Pager.GoToNextTitle" })} rel="next">
          <span className="icon icon--inline" aria-hidden={true}>
            <svg>
              <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#arrow-right" />
            </svg>
          </span>
          <span className="hidden--visually">{intl.formatMessage({ id: "Pager.GoToNextHidden" })}</span>
        </Link>
      </li>;
  }

  if (props.last && Object.keys(props.last).length) {
    last =
      <li className="pagination__item" data-rs-pagination-control="data-rs-pagination-control">
        <Link onClick={scrollTo} to={props.last.url} onMouseDown={props.last.onMouseDown} title={intl.formatMessage({ id: "Pager.GoToLastTitle" })}>
          <span aria-hidden={true}>{intl.formatMessage({ id: "Pager.GoToLastLabel" })}</span>
          <span className="hidden--visually">{intl.formatMessage({ id: "Pager.GoToLastHidden" })}</span>
        </Link>
      </li>;
  }

  return (
    <nav className="pagination divider divider--top" data-rs-pagination="data-rs-pagination" aria-labelledby="pagination">
      <ul className="pagination__list" data-rs-pagination-list="data-rs-pagination-list">
        {first}
        {previous}
        {pages}
        {next}
        {last}
      </ul>
    </nav>
  );
}

export default injectIntl(Pager);